import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import DelayedLoader from './DelayedLoader';
import messages from './messages';

const TextDelayedLoader = ({
  smallWidget,
  name
}) => {
  const [showLoader, setShowLoader] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 20000);
    return () => clearTimeout(timer);
  }, []);
  return showLoader ? /*#__PURE__*/React.createElement(DelayedLoader, {
    key: "root",
    smallWidget: smallWidget,
    name: name,
    contained: true
  }) : /*#__PURE__*/React.createElement(FormattedMessage, messages.errorText);
};

export default TextDelayedLoader;